{
  "minecraft:large_fern": { "source": "grass" },
  "minecraft:tall_grass": { "source": "grass" },
  "minecraft:grass_block": { "source": "grass" },
  "minecraft:fern": { "source": "grass" },
  "minecraft:grass": { "source": "grass" },
  "minecraft:short_grass": { "source": "grass" },
  "minecraft:potted_fern": { "source": "grass" },
  "minecraft:bush": { "source": "grass" },
  "minecraft:pink_petals": { "source": "grass", "untinted": [0] },
  "minecraft:wildflowers": { "source": "grass", "untinted": [0] },
  "minecraft:spruce_leaves": { "source": "constant", "color": 6396257 },
  "minecraft:birch_leaves": { "source": "constant", "color": 8431445 },
  "minecraft:oak_leaves": { "source": "constant", "color": 4764952 },
  "minecraft:jungle_leaves": { "source": "constant", "color": 4764952 },
  "minecraft:acacia_leaves": { "source": "constant", "color": 4764952 },
  "minecraft:dark_oak_leaves": { "source": "constant", "color": 4764952 },
  "minecraft:vine": { "source": "constant", "color": 4764952 },
  "minecraft:mangrove_leaves": { "source": "constant", "color": 4764952 },
  "minecraft:leaf_litter": { "source": "constant", "color": 6044722 },
  "minecraft:water_cauldron": { "source": "constant", "color": 4159204 },
  "minecraft:redstone_wire": { "source": "redstone" },
  "minecraft:attached_melon_stem": { "source": "constant", "color": 14731036 },
  "minecraft:attached_pumpkin_stem": { "source": "constant", "color": 14731036 },
  "minecraft:melon_stem": { "source": "stem" },
  "minecraft:pumpkin_stem": { "source": "stem" },
  "minecraft:lily_pad": { "source": "constant", "color": 7455580 }
}
